// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { SwitchControl } from "../../molecules";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { Button, Loading } from "../../atoms";
import {
  IMerchant,
  useMerchantRestrictionAdd,
  useMerchantRestrictionUpdate,
} from "../../../hooks";
import { useEffect } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  fourthStepFormSchema,
  FourthStepFormValuesType,
  fourthStepInitialValues,
} from "./_formTypes";
import { useSetSnackBar } from "../../../store/Snackbar.state";

type MerchantAddFormCompanyStepProps = {
  merchant?: IMerchant;
  onBack: () => void;
  allData?: any;
  setAllData?: any;
};

export const MerchantAddFormCurrencyStep = ({
  merchant,
  onBack,
  allData,
  setAllData
}: MerchantAddFormCompanyStepProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const setSnackbar = useSetSnackBar();
  const { mutate: merchantRestrictionAdd, isLoading } =
    useMerchantRestrictionAdd();
  const { mutate: merchantRestrictionUpdate, isUpdateLoading } =
    useMerchantRestrictionUpdate();
  const { control, reset, handleSubmit } = useForm<FourthStepFormValuesType>({
    resolver: zodResolver(fourthStepFormSchema),
    defaultValues: fourthStepInitialValues,
  });

  const onSubmit = ({
    try: tryCurrency,
    usd: usdCurrency,
    eur: eurCurrency,
  }: FourthStepFormValuesType) => {
    tryCurrency = tryCurrency == null ? false : tryCurrency;
    usdCurrency = usdCurrency == null ? false : usdCurrency;
    eurCurrency = eurCurrency == null ? false : eurCurrency;
    const request = {
      merchantId: allData?.merchantId,
      try: tryCurrency,
      usd: usdCurrency,
      eur: eurCurrency,
    };

    const isCurrencyAlreadyAdded = allData?.try != null || allData?.usd != null || allData?.eur != null;

    if ((merchant && merchant?.id > 0 && isCurrencyAlreadyAdded)) {
      merchantRestrictionUpdate(
        { ...request, id: merchant?.id || 0 },
        {
          onSuccess(data) {
            if (data.isSuccess) {
              setAllData({ ...allData, ...request });
              localStorage.setItem("fromEditPage", "true");
              setSnackbar({
                severity: "success",
                isOpen: true,
                description: data.message,
              });
            } else {
              setSnackbar({
                severity: "error",
                isOpen: true,
                description: data.message,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: "İşlem sırasında bir hata oluştu",
            });
          },
        }
      );
    } else {
      merchantRestrictionAdd(request, {
        onSuccess(data) {
          if (data.isSuccess) {
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message,
            });
          } else {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: data.message,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "İşlem sırasında bir hata oluştu",
          });
        },
      });
    }
  };

  useEffect(() => {
    if (!!merchant && JSON.stringify(merchant) !== "{}") {
      reset({
        try: merchant.try,
        usd: merchant.usd,
        eur: merchant.eur,
      });
    }
  }, [merchant, reset]);


  return (
    <>
      {(isLoading || isUpdateLoading) && <Loading />}
      <Box p={isDesktop ? 3 : 2}>
        <Stack spacing={3}>
          <Card variant="outlined">
            <CardHeader
              title="Para Birimi Kısıtlamaları"
              subheader="İşyeri için izin verilen işlem para birimlerini seçin."
            />
            <CardContent>
              <Stack
                spacing={2}
                direction={isDesktop ? "row" : "column"}
                divider={isDesktop ? <Divider orientation="vertical" flexItem /> : <Divider />}
              >
                <Box sx={{ flex: 1, p: 2 }}>
                  <SwitchControl
                    label="TRY (Türk Lirası)"
                    control={control}
                    id="try"
                  />
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                    Türk Lirası ile işlem yapılmasına izin verir.
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, p: 2 }}>
                  <SwitchControl
                    label="USD (Amerikan Doları)"
                    control={control}
                    id="usd"
                  />
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                    Amerikan Doları ile işlem yapılmasına izin verir.
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, p: 2 }}>
                  <SwitchControl
                    label="EUR (Euro)"
                    control={control}
                    id="eur"
                  />
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                    Euro ile işlem yapılmasına izin verir.
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>
          <Stack direction="row" justifyContent="flex-end">
            <Button
              variant="contained"
              text="Kaydet"
              onClick={handleSubmit(onSubmit)}
            />
          </Stack>
        </Stack>
      </Box>
    </>
  );
};

